import { useEffect } from 'react'
import { setupInteractionTracking } from '../lib/analytics'

export default function Analytics() {
  useEffect(() => setupInteractionTracking(), [])
  return null
}
